import React from 'react'
import MaterialAdminLayout from './MaterialAdminLayout'

const AdminDashboard = () => <MaterialAdminLayout />

export default AdminDashboard
